export default __webpack_public_path__ + "static/media/fighter-icon.d2103fcc.png";